import React from 'react'
import AsyncComponent from './async.component'
import { routes } from '../../constants/routes.constants'
import { connect } from 'react-redux'
import { UserService } from '../../services/user.service'
import { Route, withRouter, Redirect } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'

export class PrivateRouteComponent extends React.Component {
	constructor(props) {
		super(props)
	}



	// Authorization is handled at render time inside the Route below

	render() {
		return renderContent.call(this)
	}
}

function renderContent() {
	const {
		module: Module,
		layout: Layout,
		roles,
		noPadding,
		user,
		...rest
	} = this.props

	return (
		<Route
			{...rest}
			render={routeProps => {
				if (!user) return <Redirect to={routes.ENTRAR} />

				if (
					!user.roles ||
					!roles.find(role => user.roles.find(userRole => userRole.toUpperCase() === role.toUpperCase()))
				) {
					return <Redirect to="/" />
				}

				return Layout ? (
					<Layout noPadding={noPadding} key={routeProps.location.pathname}>
						<AsyncComponent moduleProvider={Module} {...routeProps} key={routeProps.location.pathname} />
					</Layout>
				) : (
					<AsyncComponent moduleProvider={Module} {...routeProps} key={routeProps.location.pathname} />
				)
			}}
		/>
	)
}

const mapStoreToProps = store => {
	const { site, user } = store
	return {
		...site,
		user: user
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators
		},
		dispatch
	)

const PrivateRoute = withRouter(
	connect(mapStoreToProps, mapDispatchToProps)(PrivateRouteComponent)
)

export { PrivateRoute }
